import type {BurnFamily,LiveBlock} from "../../shared/types";

export function blockSourceFamilies(block:LiveBlock):BurnFamily[]{
  const detailed=block.originBreakdown
    ?.filter((origin)=>BigInt(origin.amountWei)>0n)
    .map((origin)=>origin.family)??[];
  if(detailed.length)return [...new Set(detailed)];
  const fallback:BurnFamily[]=[];
  if(BigInt(block.canonicalBurnWei)>0n)fallback.push("canonical_burn");
  if(BigInt(block.feeBurnWei)>0n)fallback.push(block.dominantFamily);
  return [...new Set(fallback)];
}
